import { useEffect, useState, useCallback } from "react";
import "./App.css";

// Sezioni
import Hero from "./components/hero";
import Header from "./components/header";
import Sezione2 from "./components/sezione2";
import Sezione3 from "./components/sezione3";
import SezioneEventi from "./components/sezione-eventi";
import Sezione4 from "./components/sezione4";
import Sezione5 from "./components/sezione5";
import Footer from "./components/footer";
import BackToTop from "./components/back-to-top";

// Popup (IT)
import Sezione2popup1 from "./components/popup/it/sezione-2-popup-1";
import Sezione2popup2 from "./components/popup/it/sezione-2-popup-2";
import Sezione3popup1 from "./components/popup/it/sezione-3-popup-1";
import Sezione3popup2Grecia from "./components/popup/it/sezione-3-popup-2-grecia";
import Sezione3popup3 from "./components/popup/it/sezione-3-popup-3";
import PopupNumeri from "./components/popup/it/sezione-4-popup-1-numeri";
import PopupEconomicoPatrimoniale from "./components/popup/it/sezione-4-popup-2";
import PopupImpegnoPersone from "./components/popup/it/sezione-4-popup-3";
import Sezione4Approfondimento from "./components/popup/it/sezione-4-popup-approfondimento";
import AnalisiApprofondimento from "./components/popup/it/sezione-5-Analisi-Approfondimento";
import AnalisiECG from "./components/popup/it/sezione-5-Analisi";
import Care from "./components/popup/it/sezione-5-Care";
import Documenti from "./components/popup/it/sezione-5-Documenti";
import StakeholderEngagement from "./components/popup/it/sezione-5-Engagement";
import ModelloBusiness from "./components/popup/it/sezione-5-Modello";
import Network from "./components/popup/it/sezione-5-Network";
import Premi from "./components/popup/it/sezione-5-Premi";
import BeneficioComune from "./components/popup/it/sezione-5-Sostenibilita-approfondimento-1";
import PSIPopup from "./components/popup/it/sezione-5-Sostenibilita-approfondimento-2";
import MutualitaSostenibilita from "./components/popup/it/sezione-5-Sostenibilita-approfondimento-3";
import MissionVisionPurpose from "./components/popup/it/sezione-5-Sostenibilita-approfondimento-4";
import ModelloSostenibilita from "./components/popup/it/sezione-5-Sostenibilita";
import Stakeholder from "./components/popup/it/sezione-5-Stakeholder";

export default function App() {
  // === STATE per ciascun popup ===
  const [openSezione2popup1, setOpenSezione2popup1] = useState(false);
  const [openSezione2popup2, setOpenSezione2popup2] = useState(false);
  const [openSezione3popup1, setOpenSezione3popup1] = useState(false);
  const [openSezione3popup2Grecia, setOpenSezione3popup2Grecia] = useState(false);
  const [openSezione3popup3, setOpenSezione3popup3] = useState(false);
  const [openPopupNumeri, setOpenPopupNumeri] = useState(false);
  const [openPopupEconomicoPatrimoniale, setOpenPopupEconomicoPatrimoniale] = useState(false);
  const [openPopupImpegnoPersone, setOpenPopupImpegnoPersone] = useState(false);
  const [openSezione4Approfondimento, setOpenSezione4Approfondimento] = useState(false);
  const [openAnalisiApprofondimento, setOpenAnalisiApprofondimento] = useState(false);
  const [openAnalisiECG, setOpenAnalisiECG] = useState(false);
  const [openCare, setOpenCare] = useState(false);
  const [openDocumenti, setOpenDocumenti] = useState(false);
  const [openStakeholderEngagement, setOpenStakeholderEngagement] = useState(false);
  const [openModelloBusiness, setOpenModelloBusiness] = useState(false);
  const [openNetwork, setOpenNetwork] = useState(false);
  const [openPremi, setOpenPremi] = useState(false);
  const [openBeneficioComune, setOpenBeneficioComune] = useState(false);
  const [openPSIPopup, setOpenPSIPopup] = useState(false);
  const [openMutualitaSostenibilita, setOpenMutualitaSostenibilita] = useState(false);
  const [openMissionVisionPurpose, setOpenMissionVisionPurpose] = useState(false);
  const [openModelloSostenibilita, setOpenModelloSostenibilita] = useState(false);
  const [openStakeholder, setOpenStakeholder] = useState(false);

  // === Mappa id -> setter ===
  const popupSetters = {
    Sezione2popup1: setOpenSezione2popup1,
    Sezione2popup2: setOpenSezione2popup2,
    Sezione3popup1: setOpenSezione3popup1,
    Sezione3popup2Grecia: setOpenSezione3popup2Grecia,
    Sezione3popup3: setOpenSezione3popup3,
    PopupNumeri: setOpenPopupNumeri,
    PopupEconomicoPatrimoniale: setOpenPopupEconomicoPatrimoniale,
    PopupImpegnoPersone: setOpenPopupImpegnoPersone,
    Sezione4Approfondimento: setOpenSezione4Approfondimento,
    AnalisiApprofondimento: setOpenAnalisiApprofondimento,
    AnalisiECG: setOpenAnalisiECG,
    Care: setOpenCare,
    Documenti: setOpenDocumenti,
    StakeholderEngagement: setOpenStakeholderEngagement,
    ModelloBusiness: setOpenModelloBusiness,
    Network: setOpenNetwork,
    Premi: setOpenPremi,
    BeneficioComune: setOpenBeneficioComune,
    PSIPopup: setOpenPSIPopup,
    MutualitaSostenibilita: setOpenMutualitaSostenibilita,
    MissionVisionPurpose: setOpenMissionVisionPurpose,
    ModelloSostenibilita: setOpenModelloSostenibilita,
    Stakeholder: setOpenStakeholder,
  };

  // === openPopup(id) da passare alle sezioni se serve ===
  const openPopup = useCallback((id) => {
    const setter = popupSetters[id];
    if (setter) setter(true);
  }, []); // popupSetters è stabile perché definito inline con referenze stabili ai setter

  // === onShare (link con ?popup=<id>) ===
  const makeShareUrl = useCallback((popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);
    return url.toString();
  }, []);

  const makeOnShareFor = useCallback(
    (popupId) => () => {
      const url = makeShareUrl(popupId);
      if (navigator.share) {
        navigator.share({ title: "Lettera agli Stakeholder", url }).catch(() => {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).catch(() => {});
      }
    },
    [makeShareUrl]
  );

  // === All'arrivo: apri SUBITO il popup da ?popup= e pulisci l'URL ===
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("popup");
    if (id && popupSetters[id]) {
      popupSetters[id](true);
      // pulizia URL (rimuove solo "popup", preserva altri parametri e hash)
      params.delete("popup");
      const newSearch = params.toString();
      const newUrl =
        window.location.pathname +
        (newSearch ? `?${newSearch}` : "") +
        window.location.hash;
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  return (
    <>
      <Header />
      <Hero openPopup={openPopup} />
      <Sezione2 openPopup={openPopup} />
      <Sezione3 openPopup={openPopup} />
      <SezioneEventi />
      <Sezione4 openPopup={openPopup} />
      <Sezione5 openPopup={openPopup} />
      <Footer />
      <BackToTop />

      {/* Render dei popup esistenti con isOpen/onClose e onShare pre-bound */}
      <Sezione2popup1
        isOpen={openSezione2popup1}
        onClose={() => setOpenSezione2popup1(false)}
        onShare={makeOnShareFor("Sezione2popup1")}
      />
      <Sezione2popup2
        isOpen={openSezione2popup2}
        onClose={() => setOpenSezione2popup2(false)}
        onShare={makeOnShareFor("Sezione2popup2")}
      />
      <Sezione3popup1
        isOpen={openSezione3popup1}
        onClose={() => setOpenSezione3popup1(false)}
        onShare={makeOnShareFor("Sezione3popup1")}
      />
      <Sezione3popup2Grecia
        isOpen={openSezione3popup2Grecia}
        onClose={() => setOpenSezione3popup2Grecia(false)}
        onShare={makeOnShareFor("Sezione3popup2Grecia")}
      />
      <Sezione3popup3
        isOpen={openSezione3popup3}
        onClose={() => setOpenSezione3popup3(false)}
        onShare={makeOnShareFor("Sezione3popup3")}
      />
      <PopupNumeri
        isOpen={openPopupNumeri}
        onClose={() => setOpenPopupNumeri(false)}
        onShare={makeOnShareFor("PopupNumeri")}
      />
      <PopupEconomicoPatrimoniale
        isOpen={openPopupEconomicoPatrimoniale}
        onClose={() => setOpenPopupEconomicoPatrimoniale(false)}
        onShare={makeOnShareFor("PopupEconomicoPatrimoniale")}
      />
      <PopupImpegnoPersone
        isOpen={openPopupImpegnoPersone}
        onClose={() => setOpenPopupImpegnoPersone(false)}
        onShare={makeOnShareFor("PopupImpegnoPersone")}
      />
      <Sezione4Approfondimento
        isOpen={openSezione4Approfondimento}
        onClose={() => setOpenSezione4Approfondimento(false)}
        onShare={makeOnShareFor("Sezione4Approfondimento")}
      />
      <AnalisiApprofondimento
        isOpen={openAnalisiApprofondimento}
        onClose={() => setOpenAnalisiApprofondimento(false)}
        onShare={makeOnShareFor("AnalisiApprofondimento")}
      />
      <AnalisiECG
        isOpen={openAnalisiECG}
        onClose={() => setOpenAnalisiECG(false)}
        onShare={makeOnShareFor("AnalisiECG")}
      />
      <Care
        isOpen={openCare}
        onClose={() => setOpenCare(false)}
        onShare={makeOnShareFor("Care")}
      />
      <Documenti
        isOpen={openDocumenti}
        onClose={() => setOpenDocumenti(false)}
        onShare={makeOnShareFor("Documenti")}
      />
      <StakeholderEngagement
        isOpen={openStakeholderEngagement}
        onClose={() => setOpenStakeholderEngagement(false)}
        onShare={makeOnShareFor("StakeholderEngagement")}
      />
      <ModelloBusiness
        isOpen={openModelloBusiness}
        onClose={() => setOpenModelloBusiness(false)}
        onShare={makeOnShareFor("ModelloBusiness")}
      />
      <Network
        isOpen={openNetwork}
        onClose={() => setOpenNetwork(false)}
        onShare={makeOnShareFor("Network")}
      />
      <Premi
        isOpen={openPremi}
        onClose={() => setOpenPremi(false)}
        onShare={makeOnShareFor("Premi")}
      />
      <BeneficioComune
        isOpen={openBeneficioComune}
        onClose={() => setOpenBeneficioComune(false)}
        onShare={makeOnShareFor("BeneficioComune")}
      />
      <PSIPopup
        isOpen={openPSIPopup}
        onClose={() => setOpenPSIPopup(false)}
        onShare={makeOnShareFor("PSIPopup")}
      />
      <MutualitaSostenibilita
        isOpen={openMutualitaSostenibilita}
        onClose={() => setOpenMutualitaSostenibilita(false)}
        onShare={makeOnShareFor("MutualitaSostenibilita")}
      />
      <MissionVisionPurpose
        isOpen={openMissionVisionPurpose}
        onClose={() => setOpenMissionVisionPurpose(false)}
        onShare={makeOnShareFor("MissionVisionPurpose")}
      />
      <ModelloSostenibilita
        isOpen={openModelloSostenibilita}
        onClose={() => setOpenModelloSostenibilita(false)}
        onShare={makeOnShareFor("ModelloSostenibilita")}
      />
      <Stakeholder
        isOpen={openStakeholder}
        onClose={() => setOpenStakeholder(false)}
        onShare={makeOnShareFor("Stakeholder")}
      />
    </>
  );
}